/** Helpers for Settings → Automation GitHub PR repo config (/automation/v1/repo-config). */

export const DEFAULT_AUTOMATION_REPO_CONFIG = {
  repo_config_id: null,
  repo_owner: null,
  repo_name: null,
  repo_url: '',
  base_branch: 'main',
  automation_base_path: 'tests/stratovai/generated',
  enabled: false,
  token_configured: false,
  verified: false,
  verification_required: true,
  last_verified_at: null,
  last_verification_status: null,
  credential_type: null,
  credential_status: null,
  updated_at: null,
};

export function buildGithubRepoUrl(repoOwner, repoName) {
  if (!repoOwner || !repoName) {
    return '';
  }
  return `https://github.com/${repoOwner}/${repoName}`;
}

export function mapRepoConfigResponse(data) {
  if (!data || typeof data !== 'object') {
    return { ...DEFAULT_AUTOMATION_REPO_CONFIG };
  }
  return {
    repo_config_id: data.repo_config_id || data.id || null,
    repo_owner: data.repo_owner || null,
    repo_name: data.repo_name || null,
    repo_url: data.repo_url || buildGithubRepoUrl(data.repo_owner, data.repo_name),
    base_branch: data.base_branch || 'main',
    automation_base_path: data.automation_base_path || 'tests/stratovai/generated',
    enabled: Boolean(data.enabled),
    token_configured: Boolean(data.token_configured),
    verified: Boolean(data.verified),
    verification_required: data.verification_required !== false,
    last_verified_at: data.last_verified_at || null,
    last_verification_status: data.last_verification_status || null,
    credential_type: data.credential_type || null,
    credential_status: data.credential_status || null,
    updated_at: data.updated_at || null,
  };
}

export function buildRepoConfigUpsertBody({ projectId, repoConfig, tokenInput }) {
  const body = {
    project_id: projectId,
    repo_url: repoConfig.repo_url,
    default_branch: repoConfig.base_branch,
    base_branch: repoConfig.base_branch,
    automation_base_path: repoConfig.automation_base_path,
    enabled: Boolean(repoConfig.enabled),
  };
  if (tokenInput && tokenInput.trim()) {
    body.token = tokenInput.trim();
  }
  return body;
}

export function repoConfigSnapshotMatches(left, right) {
  if (!left || !right) {
    return false;
  }
  return (
    left.repo_url === right.repo_url
    && left.base_branch === right.base_branch
    && left.automation_base_path === right.automation_base_path
    && Boolean(left.enabled) === Boolean(right.enabled)
    && Boolean(left.token_configured) === Boolean(right.token_configured)
  );
}

/** Legacy project_config keys — not written by Settings Automation save anymore. */
export const LEGACY_AUTOMATION_REPO_CONFIG_KEYS = new Set([
  'automation.repo_provider',
  'automation.repo_url',
  'automation.repo_token',
]);
